import { put, call, select, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import { Endpoints } from "services/api";

const getTenant = (state) => state.userLogin.tenant;
const getUser = (state) => state.userLogin.user;

function* fetchUserNotificationPermission(api, tenantId, userId) {
    const result = yield call([api, api.get], `${Endpoints.permissions}/api/v1/users/${userId}/permissions/resources/notifications`, { tenantid: tenantId });
    return result.data;
}

export function* getUserNotificationPermissionRequest(api) {
    try {
        const tenant = yield select(getTenant);
        const user = yield select(getUser);
        const permissionResponse = yield call(fetchUserNotificationPermission, api, tenant.tenantId, user.userId);

        let permission = { canView: false };
        if (permissionResponse?.Items?.length > 0) {
            const actions = permissionResponse.Items[0].actions || [];
            if (actions.includes("view")) {
                permission.canView = true;
            }
            if (actions.includes("edit")) {
                permission.canEdit = true;
            }
            if (actions.includes("delete")) {
                permission.canDelete = true;
            }
            if (actions.includes("add")) {
                permission.canCreate = true;
            }
        }

        yield put({
            type: actions.GET_USER_NOTIFICATION_PERMISSION_SUCCESS,
            payload: permission,
        });
    } catch (error) {
        yield put({
            type: actions.GET_USER_NOTIFICATION_PERMISSION_FAILURE,
            payload: error.message,
        });
    }
}

export function* watchGetUserNotificationPermissionRequest(api) {
    yield takeLatest(actions.GET_USER_NOTIFICATION_PERMISSION_REQUEST, getUserNotificationPermissionRequest, api);
}

export default function* ({ api }) {
    yield watchGetUserNotificationPermissionRequest(api);
}
